<template>
  <div class="flex w-full bg-white border-default">
    <div class="second">
      <div class="flex align-center">
        <SmartIcon :size="2" name="mobile" type="small"/>
        <SmartTitle class="ml-2"
                    heading=3
        >{{ label }}
        </SmartTitle>
      </div>

      <SmartTitle class="mb-2 mt-2">
        {{ value }}
      </SmartTitle>

      <SmartButton secondary>
        {{ btnText }}
      </SmartButton>
    </div>

    <div class="third">
      <p>Here gonna be the graphic</p>
    </div>
  </div>
<!-- just structure bones -->
</template>

<script>
// @flow
export default {
  name: 'SmartCardGraphic',
  components: {
    SmartButton: () => import('packages/SmartButton'),
    SmartIcon: () => import('packages/SmartIcon'),
    SmartTitle: () => import('packages/SmartTitle')

  },
  props: {
    label: {
      type: String,
      required: true,
      default: 'Text here'
    },
    value: {
      type: Number
    },
    btnText: {
      type: String,
      required: true,
      default: 'Text button'
    }
  }
};
</script>

<style scoped lang="scss">

.second, .third {
  padding: $spacing-margin-xsmall;
}

</style>
